const regex = new RegExp([
    /(<\d+>)?/,
    /([a-z]{3})\s+/,
    /(\d{1,2})\s+/,
    /(\d{2}):/,
    /(\d{2}):/,
    /(\d{2})/,
    /(\s+[\w.-]+)?\s+/,
    /([\w\-().\d/]+)/,
    /(?:\[([a-z\d-.]+)])?:/,
    /(.+)/, // 10  message
]
    .map(regex => regex.source)
    .join(''), 'i');
const facilities = [
    'kern',
    'user',
    'mail',
    'daemon',
    'auth',
    'syslog',
    'lpr',
    'news',
    'uucp',
    'cron',
    'authpriv',
    'ftp',
    'ntp',
    'logaudit',
    'logalert',
    'clock',
    'local0',
    'local1',
    'local2',
    'local3',
    'local4',
    'local5',
    'local6',
    'local7',
];
const severities = [
    'emerg',
    'alert',
    'crit',
    'err',
    'warning',
    'notice',
    'info',
    'debug',
];
const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
const syslogParse = (log) => {
    var _a, _b, _c;
    const parts = regex.exec(log.trim());
    if (!parts) {
        return;
    }
    const priority = Number(((_a = parts[1]) !== null && _a !== void 0 ? _a : '').replace(/\D/g, ''));
    // eslint-disable-next-line no-bitwise
    const facilityCode = priority >> 3;
    const facility = facilities[facilityCode];
    // eslint-disable-next-line no-bitwise
    const severityCode = priority & 7;
    const severity = severities[severityCode];
    const month = months.indexOf(parts[2]);
    const date = Number(parts[3]);
    const hours = Number(parts[4]);
    const minutes = Number(parts[5]);
    const seconds = Number(parts[6]);
    const time = new Date();
    time.setMonth(month);
    time.setDate(date);
    time.setHours(hours);
    time.setMinutes(minutes);
    time.setSeconds(seconds);
    const host = ((_b = parts[7]) !== null && _b !== void 0 ? _b : '').trim();
    const processName = parts[8];
    const pid = Number(parts[9]);
    const message = ((_c = parts[10]) !== null && _c !== void 0 ? _c : '').trim();
    const result = {
        priority,
        facilityCode,
        facility,
        severityCode,
        severity,
        time,
        host,
        process: processName,
        message,
    };
    if (pid) {
        result.pid = pid;
    }
    return result;
};
export default syslogParse;
